import * as projects from "../api/projects";

export default {
  state: {
    project: {},
    projects: [],
    users: [],
    status: [],
    benefits: [],
    providers: [],
    types: [],
    userProject: []
  },
  mutations: {
    getProjects(state, projects) {
      state.projects = projects;
    },
    getProject(state, project) {
      state.project = project;
    },
    getUsers(state, users) {
      state.users = users;
    },
    getStatus(state, status) {
      state.status = status;
    },
    getBenefits(state, benefits) {
      state.benefits = benefits;
    },
    getProviders(state, providers) {
      state.providers = providers;
    },
    getTypes(state, types) {
      state.types = types;
    },
    getUserInProject(state, userProject) {
      state.userProject = userProject;
    }
  },
  actions: {
    async getProjects({ commit }) {
      const data = await projects.getProjects();
      commit("getProjects", data);
    },
    async getProject({ commit }, id) {
      const data = await projects.getProject(id);
      commit("getProject", data);
    },
    async getUserInProject({ commit }, id) {
      const data = await projects.getUserInProject(id);
      commit("getUserInProject", data);
    },
    async createProject({ dispatch }, project) {
      try {
        const response = await projects.createProject(project);
        dispatch("getProjects");
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updateProject({ dispatch }, { id, project }) {
      try {
        const response = await projects.updateProject(id, project);

        dispatch("getProjects");
        dispatch("getProject", id);

        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async deleteProject({ dispatch }, { id }) {
      try {
        const response = await projects.deleteProject(id);
        dispatch("getProjects");
        return response;
      } catch (error) {
        return { success: false };
      }
    },
    async getStatus({ commit }) {
      commit("getStatus", await projects.getStatus());
    },
    async getUsers({ commit }) {
      commit("getUsers", await projects.getUsers());
    },
    async getBenefits({ commit }) {
      commit("getBenefits", await projects.getBenefits());
    },
    async getTypes({ commit }) {
      commit("getTypes", await projects.getTypes());
    },
    async addInvoice({ dispatch }, { number, amount, project_id }) {
      const response = await projects.addInvoice(number, amount, project_id);

      if (response.id) dispatch("getProject", project_id);
      return response;
    },
    async updateInvoice({ dispatch }, { id, number, amount, project_id }) {

      const response = await projects.updateInvoice(id, number, amount, project_id);
      if (response.id) dispatch("getProject", project_id);

      return response;
    },
    async removeInvoice({ dispatch }, { id, project_id }) {
      const response = await projects.removeInvoice(id);
      if (response.success) dispatch("getProject", project_id);
      return response;
    }
  }
};
